(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3EmailModal', {
            templateUrl: 'app/shared/email-modal/email-modal.component.html',
            controller: EmailModal,
            bindings: { close: '&', dismiss: '&', resolve: '<' }
        });

    EmailModal.$inject = ['$timeout', 'Member', 'alert', 'shared_resources'];
    function EmailModal($timeout, Member, alert, resources) {
        var ctrl = this;
        ctrl.$onInit = init;
        ctrl.submit = submit;

        function init() {
            ctrl.email = ctrl.resolve.email;
        }

        function submit() {
            if (ctrl.form.$valid) 
                Member.sendEmail(ctrl.email, success, error, true);

            function success() {
                ctrl.close();
                $timeout(showSuccess, 0, false);
            }
            function error() {
                alert.error(resources.emailFailed, ctrl.email.address);
            }
            function showSuccess() {
                alert.success(resources.emailSuccess, ctrl.email.address);
            }
        }
    }
})();